<template>
    <div v-if="history.length" class="shift-history-grid">
        <ShiftHistoryListItem
            v-for="(record, index) in history"
            :key="record.id ?? record.history_id ?? index"
            :record
            :previous-record="history[index + 1]"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/stores/scheduleStore';
import ShiftHistoryListItem from './ShiftHistoryListItem.vue';

const store = useScheduleStore()
const history = computed(() => store.shiftHistory)
</script>

<style scoped>
/* Две колонки «время | событие» (RD-140). */
.shift-history-grid {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr);
    gap: 10px 12px;
    font-size: 12px;
    line-height: 140%;
    color: var(--color-text-main);
}
</style>
